import { valueType_EnumElement, valueType_Enumerated, valueType_Range, valueType_StandardRange, valueType_SubEnumerated, valueType_SubRange, valueType_SubTime, valueType_Time, valueType_TimeRange, valueType_Tuple } from './consts.js';
import { resolveTimeRangeDisplay } from './utility.js';
import { capitalizeFirstLetter } from '@nu-art/ts-common';
export const resolveValueDisplay = (value, capitalize) => {
    // @ts-ignore
    const result = '' + ValueRenderer[value.type](value);
    if (!capitalize)
        return result;
    return capitalizeFirstLetter(result).replace(/^(\d+:\s*)([a-z])/, (_match, prefix, char) => prefix + char.toUpperCase());
};
const defaultValueTypeRenderer = (value) => {
    if (!value.label)
        console.log(value);
    return value.label;
};
export const ValueRenderer = {
    [valueType_EnumElement]: (value) => value.data.value,
    [valueType_SubRange]: (value) => `${value.data.scope[0]} ... ${value.data.scope[1]} ${(value.data.label
        ? `: ${value.data.label}`
        : '')}`,
    [valueType_SubEnumerated]: defaultValueTypeRenderer,
    [valueType_Enumerated]: defaultValueTypeRenderer,
    [valueType_Range]: defaultValueTypeRenderer,
    [valueType_Tuple]: defaultValueTypeRenderer,
    [valueType_StandardRange]: defaultValueTypeRenderer,
    [valueType_Time]: (value) => '',
    [valueType_TimeRange]: resolveTimeRangeDisplay,
    [valueType_SubTime]: () => ''
};
//# sourceMappingURL=resolve-value-display.js.map